module.exports = __webpack_public_path__ + "img/02-01.487e1311.png";